// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --mainLight: #546073;
    --mainDark: #2d3333;
}

#root {
    width: 100vw;
    height: 100vh;
}

.App {
    width: 100vw;
    height: 100vh;
    /*background-color: rgb(180, 84, 84);*/
    text-align: center;
    display: inline-flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
}

h1.main-title {
    margin-top: 50px;
    border: 5px solid black;
    padding: 10px;
}

body {
    /*background-color: rgba(26, 180, 180, 0.6);*/
    background-color: rgba(120, 120, 120, 0.6);
}

select:focus-visible {
    outline: none;
}

.search-tools div {
    margin-top: 30px;
}

.search-tools div#search-form {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: flex-end;
    width: -moz-fit-content;
    width: fit-content;
}

.search-tools div#search-form > section {
    display: block;
    float: left;
}

.search-tools div#search-form > input, label {
    /*display: block !important;*/
}

.search-tools div#search-form * {
    /*display: inline-flex;*/
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
    margin: 0px 4px;
}

.search-tools div#search-form input[type=text] {
    outline: none;
    width: 250px;
    height: 40px;
    font-size: 24px;
    border: 2px solid black;
    box-sizing: border-box;
}
.search-tools div#search-form input:focus {
    outline: none;
    border: 1px solid black;
}

.search-tools div#search-form section#type-select {
    width: -moz-fit-content;
    width: fit-content;
}

.search-tools div#search-form section#mcjx-section {
    /*display: inline-flex !important;*/
    /*align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;*/
    margin: auto;
}

.search-tools div#search-form section#mcjx-section > select {
    width: 325px;
    height: 50px;
    font-size: 15px;
    font-weight: bold;
}

button {
    color: white;
    border: none;
    background-color: var(--mainLight);
    width: 50px;
    height: 40px;
    text-align: center;
    cursor: pointer;
    /*border: 2px solid var(--mainLight);*/
    border: 2px solid #6a798f;
}
button:hover {
    text-shadow: 0px 0px 2px #b4c4de;
    cursor: pointer;
    border: 2px solid var(--mainDark);
}

.button-disconnect {
    width: -moz-fit-content;
    width: fit-content; /* Ou spécifiez une taille fixe qui correspond à la taille de l'image */
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0 0;
    border: none; /* Supprimer la bordure si l'image doit couvrir tout le bouton */
    padding: 0;
}

#searchQRCode-button {
    width: 250px !important;
    height: 50px;
    margin-top: 20px;
}

table {
    text-align: center;
    border-collapse: collapse;
    width: 50%;
    margin-top: 30px;
    font-size: 30px;
}

th {
    border: 1px solid black;
    padding: 5px 0px;
    color: black;
}

td {
    height: 50px;
    border: 1px solid black;
    /*overflow-x: auto;*/
}

div > fieldset > legend{
    font-weight: bold;
}

fieldset {
    border-width: 3px;
}

div.display-result > fieldset {
    text-align: left;
    padding: 10px 30px 10px 30px;
}

div.display-result > fieldset > legend {
    text-align: center;
}

div.display-result > fieldset:not(:first-child) {
    margin-top: 20px;
}

.form-login {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 0fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    align-content: center;
    justify-content: center;
    align-items: center;
    justify-items: center;
}

.form-login > label {
    justify-self: end;
}

.form-login > label:first-child {
    grid-area: 1 / 1 / 2 / 2;
}

.form-login > input:first-child {
    grid-area: 1 / 2 / 2 / 3;
}

.form-login > label:last-child {
    grid-area: 2 / 1 / 3 / 2;
}

.form-login > input:last-child {
    grid-area: 2 / 2 / 3 / 3;
}

.form-login > button {
    grid-area: 3 / 1 / 4 / 3;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,6CAA6C;IAC7C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC;;;2BAGuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,yBAAyB;AAC7B;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB,EAAE,uEAAuE;IAC3F,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY,EAAE,gEAAgE;IAC9E,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,kCAAkC;IAClC,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[":root {\n    --mainLight: #546073;\n    --mainDark: #2d3333;\n}\n\n#root {\n    width: 100vw;\n    height: 100vh;\n}\n\n.App {\n    width: 100vw;\n    height: 100vh;\n    /*background-color: rgb(180, 84, 84);*/\n    text-align: center;\n    display: inline-flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    align-content: center;\n    align-items: center;\n}\n\nh1.main-title {\n    margin-top: 50px;\n    border: 5px solid black;\n    padding: 10px;\n}\n\nbody {\n    /*background-color: rgba(26, 180, 180, 0.6);*/\n    background-color: rgba(120, 120, 120, 0.6);\n}\n\nselect:focus-visible {\n    outline: none;\n}\n\n.search-tools div {\n    margin-top: 30px;\n}\n\n.search-tools div#search-form {\n    display: inline-flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-content: center;\n    justify-content: center;\n    align-items: flex-end;\n    width: fit-content;\n}\n\n.search-tools div#search-form > section {\n    display: block;\n    float: left;\n}\n\n.search-tools div#search-form > input, label {\n    /*display: block !important;*/\n}\n\n.search-tools div#search-form * {\n    /*display: inline-flex;*/\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n    margin: 0px 4px;\n}\n\n.search-tools div#search-form input[type=text] {\n    outline: none;\n    width: 250px;\n    height: 40px;\n    font-size: 24px;\n    border: 2px solid black;\n    box-sizing: border-box;\n}\n.search-tools div#search-form input:focus {\n    outline: none;\n    border: 1px solid black;\n}\n\n.search-tools div#search-form section#type-select {\n    width: fit-content;\n}\n\n.search-tools div#search-form section#mcjx-section {\n    /*display: inline-flex !important;*/\n    /*align-content: center;\n    align-items: center;\n    justify-content: center;\n    justify-items: center;*/\n    margin: auto;\n}\n\n.search-tools div#search-form section#mcjx-section > select {\n    width: 325px;\n    height: 50px;\n    font-size: 15px;\n    font-weight: bold;\n}\n\nbutton {\n    color: white;\n    border: none;\n    background-color: var(--mainLight);\n    width: 50px;\n    height: 40px;\n    text-align: center;\n    cursor: pointer;\n    /*border: 2px solid var(--mainLight);*/\n    border: 2px solid #6a798f;\n}\nbutton:hover {\n    text-shadow: 0px 0px 2px #b4c4de;\n    cursor: pointer;\n    border: 2px solid var(--mainDark);\n}\n\n.button-disconnect {\n    width: fit-content; /* Ou spécifiez une taille fixe qui correspond à la taille de l'image */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 20px 0 0;\n    border: none; /* Supprimer la bordure si l'image doit couvrir tout le bouton */\n    padding: 0;\n}\n\n#searchQRCode-button {\n    width: 250px !important;\n    height: 50px;\n    margin-top: 20px;\n}\n\ntable {\n    text-align: center;\n    border-collapse: collapse;\n    width: 50%;\n    margin-top: 30px;\n    font-size: 30px;\n}\n\nth {\n    border: 1px solid black;\n    padding: 5px 0px;\n    color: black;\n}\n\ntd {\n    height: 50px;\n    border: 1px solid black;\n    /*overflow-x: auto;*/\n}\n\ndiv > fieldset > legend{\n    font-weight: bold;\n}\n\nfieldset {\n    border-width: 3px;\n}\n\ndiv.display-result > fieldset {\n    text-align: left;\n    padding: 10px 30px 10px 30px;\n}\n\ndiv.display-result > fieldset > legend {\n    text-align: center;\n}\n\ndiv.display-result > fieldset:not(:first-child) {\n    margin-top: 20px;\n}\n\n.form-login {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(3, 0fr);\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    justify-items: center;\n}\n\n.form-login > label {\n    justify-self: end;\n}\n\n.form-login > label:first-child {\n    grid-area: 1 / 1 / 2 / 2;\n}\n\n.form-login > input:first-child {\n    grid-area: 1 / 2 / 2 / 3;\n}\n\n.form-login > label:last-child {\n    grid-area: 2 / 1 / 3 / 2;\n}\n\n.form-login > input:last-child {\n    grid-area: 2 / 2 / 3 / 3;\n}\n\n.form-login > button {\n    grid-area: 3 / 1 / 4 / 3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
